import { FC, useEffect, useState } from "react";
import { PaginationResponse } from "../../../types/common";
import { NewsDto, NewsFilter } from "../../../types/news";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { getNews } from "../../../api/transport/newsTransport";
import { extractTextFromHtml, getSiteByTeamCode, getStaticUrl, getUrlByContext } from "../../../utils";
import { LoadingNewsCard, NewsCard } from "../../../components/news/NewsCard";
import { NewsList } from "../../../components/news/NewsList";
import { SectionHeaderButton } from "../../../components/layout/SectionHeaderButton";

interface LatestNewsWidgetProps {
    newsId?: number;
    category?: number;
    title?: string;
    actionTitle?: string;
}

const LATEST_NEWS_COUNT = 9;

export const LatestNewsWidget: FC<LatestNewsWidgetProps> = ({
    newsId,
    category,
    title = 'Последние новости',
    actionTitle = 'Все новости'
}) => {
    const [news, setNews] = useState<PaginationResponse<NewsDto>>();
    const [loading, setLoading] = useState(true);
    const config = useConfiguration();

    useEffect(() => {
        setLoading(true);
        loadNews(category ? { id_cat: +category } : null);
    }, []);

    const loadNews = (filter?: NewsFilter) => {
        setLoading(true);
        getNews(0, LATEST_NEWS_COUNT + 1, getSiteByTeamCode(config.teamName), filter).then((n) => {
            setNews(n);
        }).finally(() => {
            setLoading(false);
        });
    }

    let newsCards = null;

    if (loading) {
        const cards = [];

        for (let i = 0; i < LATEST_NEWS_COUNT; i++) {
            cards.push(<LoadingNewsCard key={`loder_${i}`} />);
        }

        newsCards = (
            <>
                {cards}
            </>
        );
    } else {
        const filteredNews = newsId ? news?.data?.filter(n => n.id !== newsId) : [...news?.data];
        newsCards = filteredNews.map((news) => {
            const content = extractTextFromHtml(news.description).split('.')[0] || ' ';
            return (
                <NewsCard
                    key={news.id}
                    title={news.title}
                    content={content}
                    cover={getStaticUrl(news.image)}
                    date={news.date}
                    category={news.category}
                    url={news.url}
                />
            )
        })
    }

    return (
        <NewsList
            title={title}
            actionButton={<SectionHeaderButton title={actionTitle} url={getUrlByContext('/news/', config.teamName)}/>}
        >
            {newsCards}
        </NewsList>
    );
}